<app-server-grid 
  [configuration]="configuration"
  [(request)]="request"
  [(selection)]="selection"
  [actions]="actions"
  [isLoadOnInit]="true"
  [refresh]="refreshGrid"
  (dataLoaded)="onChaseLoaded($event)"
  [actionTemplate]="actionTemplate"
  [isMemberFile]="true"
  [views]="views"
  [refreshViews]="refreshViews"
  (selectionChange)="onMemberGridSelectionChange($event)">

  <ng-template #chaseIdColumn let-rowData>
    <app-chase-grid-chase-id class="link" [data]="rowData" [chaseIdUrl]="getRouteUrl(rowData.dataSet)"></app-chase-grid-chase-id>
  </ng-template>

  <ng-template #actionTemplate let-rowData let-localActionPopover="actionPopover">
    <div class="action-template-container">
      <app-button text="Pend Chase(s)" (onClick)="openPendModal(rowData); localActionPopover.hide();" [disabled]="projectInActiveOrArchive(rowData)"></app-button>
      <app-button text="Assign Chase(s)" (onClick)="openAssignToChaseModal(rowData); localActionPopover.hide();" [disabled]="projectInActiveOrArchive(rowData)"></app-button>
      <app-button text="Unassign Chase(s)" (onClick)="unassignToChases(rowData); localActionPopover.hide();" [disabled]="projectInActiveOrArchive(rowData)"></app-button>
      <app-button text="Download Chart" (onClick)="submitChartDownloadRequest(rowData); localActionPopover.hide();"></app-button>
      <app-button text="Copy Chart" (onClick)="openCopyChartModel(rowData); localActionPopover.hide();"></app-button>
    </div>
  </ng-template>

</app-server-grid>

<app-pend-modal 
  [(visible)]="isPendModalVisible"
  (onHide)="closeModal()"
  (onUpdate)="refreshGrid.emit()"
  [(chases)]="selectedChases"
  [clinical]="clinical"
  [hasClinicalNonClinicalChases]="hasClinicalNonClinicalChases">
</app-pend-modal>

<app-chase-assignment-modal 
  [(visible)]="isAssignToChaseModalVisible"
  (onHide)="closeModal()"
  (onUpdate)="refreshGrid.emit()"
  [(chases)]="selectedChaseIdsForAssignment"
  [isUnassignEnabled]="true">
</app-chase-assignment-modal>

<app-copy-chart-modal 
  [(visible)]="isCopyChartModelVisible"
  [(masterMemberId)]="masterMemberId"
  [(dataSet)]="dataSet"             
  (onHide)="closeModal()"
  (onUpdate)="refreshGrid.emit()"
  [(chases)]="selectedChases">
</app-copy-chart-modal>
